import { formatInputsOnMessage, is2xxStatus } from './AlertMessageLogic'

export default function messageOnAddRule(status, invalidInputs) {
    let message, inputs

    if (is2xxStatus(status)) status = '2xx'

    inputs = formatInputsOnMessage(invalidInputs)

    switch (status) {
        case 'invalid-percentage':
            message = 'Ops! Não criamos a Rule, a porcentagem das rules somadas nao podem ser maior que 99%.'
            break
        case 'invalid':
            message = `Ops! Não criamos a Rule, verifique se os campos foram preenchidos corretamente. Campo(s) inválido(s): ${inputs}.`
            break
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos adicionar a Rule.'
            break
        case '2xx':
            message = 'Adicionamos a Rule.'
            break
        case 401:
            message = 'Ops! O seu tempo de acesso expirou, para adicionar a Rule é necessário realizar o login.'
            break
        case 403:
            message = 'Permissão Negada.'
            break
        case 500:
        default:
            message = 'Ops! Algo estranho ocorreu e não adicionamos a Rule. Por favor, tente novamente mais tarde.'
    }
    return message
}
